import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import Datetime from 'react-datetime';
import styled from 'styled-components';

import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { useDelayedState } from 'utils/hooks';

import OptionsPopup from 'styles/OptionsPopup';

import FloatingMenu from 'components/FloatingMenu';
import { GeneralSettingsButton } from 'components/Buttons';

import DatePickerWrapper from '../../../components/DatePickerWrapper';

const Wrapper = styled.div`
  position: relative;
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: start;
`;

const StartDatePicker = ({ value, onChange }) => {
  const wrapperRef = useRef();
  const [visible, setVisible] = useState(false);
  const [currentValue, setCurrentValue] = useDelayedState(value, 'date', (field, newValue) => {
    onChange(newValue);
  });

  const onDateChange = newDate => {
    const newDateMoment = moment(newDate);
    newDateMoment.set({ second: 0 });
    setCurrentValue(newDateMoment.format());
  };

  return (
    <Wrapper ref={wrapperRef}>
      <GeneralSettingsButton
        reverse
        highlightedBoxShadowColor
        label={
          <TextGroup>
            <div className="text-extra-bold">Ustaw czas początkowy</div>
            <div className="text-small">Wybierz kiedy planowo zakończysz stream</div>
          </TextGroup>
        }
        color="blue"
        info={
          <>
            <p>
              {'Ustaw datę zakończenia streama, '}
              <u
                style={{
                  whiteSpace: 'nowrap',
                  fontWeight: 800,
                }}
              >
                tylko raz
              </u>
              {' przed startem transmisji.'}
            </p>
            <p>
              Zmieniając tę wartość w trakcie lajwa, zresetujesz postęp odlicznika naliczony z wpłat
              lub aktywności Kick/Twitch
            </p>
          </>
        }
        onClick={() => setVisible(true)}
        icon={<ClockIcon />}
      />

      <FloatingMenu
        visible={visible}
        position="right"
        onClose={() => setVisible(false)}
        parent={wrapperRef.current || document.body}
      >
        <OptionsPopup>
          <DatePickerWrapper>
            <Datetime
              open
              value={currentValue ? new Date(currentValue) : new Date()}
              onChange={onDateChange}
              timeFormat="HH:mm"
              input={false}
              locale="pl"
            />
          </DatePickerWrapper>
        </OptionsPopup>
      </FloatingMenu>
    </Wrapper>
  );
};

StartDatePicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.instanceOf(Function),
};

StartDatePicker.defaultProps = {
  onChange: () => null,
};

export default StartDatePicker;
